module.exports = __webpack_public_path__ + "static/media/child.1f381aa4.svg";